import { createSelector } from 'reselect';

import type { ColorState } from './color.types';

import type { ColorModel } from '~/core/models/color.model';
import type { RootState } from '~/redux/store';

export const selectColorsByProductId = ({
  color,
}: RootState): ColorState['byId'] => color.byId;

export const selectUsableColorIds = ({
  color,
}: RootState): ColorState['usableIds'] => color.usableIds;

export const selectSelectedColorId = ({
  color,
}: RootState): ColorState['selectedColorId'] => color.selectedColorId;

export const selectRestorableColorId = ({
  color,
}: RootState): ColorState['restorableColorId'] => color.restorableColorId;

export const selectUsableColors = createSelector(
  [
    ({ color }: RootState) => color.usableIds,
    ({ color }: RootState) => color.byId,
  ],
  (usableIds, colorsById): ColorModel[] => usableIds.map((id) => colorsById[id])
);

export const selectSelectedColor = createSelector(
  [
    ({ color }: RootState) => color.selectedColorId,
    ({ color }: RootState) => color.byId,
  ],
  (colorId, colorsById): ColorModel | undefined =>
    colorId ? colorsById[colorId] : undefined
);

export const selectRestorableColor = createSelector(
  [
    ({ color }: RootState) => color.restorableColorId,
    ({ color }: RootState) => color.byId,
  ],
  (colorId, colorsById): ColorModel | undefined =>
    colorId ? colorsById[colorId] : undefined
);
